export const UIKIT_COLORS = {
    PRIMARY: "#0E5AA7",
    PRIMARY_HOVER: "#0A4A8A",
    PRIMARY_LIGHT_BG: "#F5F9FF",
    PRIMARY_MAIN: "#0E5AA7", // #0E5AA7
  
    DANGER: "#DD2326",
    DANGER_HOVER: "#B71C1F",
    DANGER_BG: "#FFF5F5",
    DANGER_LIGHT_BG: "#FFE8E8",
    DANGER_BORDER: "#FECACA",
  
    WARNING_BG: "#FFFBEB",
    WARNING_BORDER: "#FCD34D",
    WARNING_TEXT: "#92400E",
  
    TEXT_PRIMARY: "#111827",
    TEXT_SECONDARY: "#6B7280",
    TEXT_MUTED: "#9CA3AF",
    TEXT_DARK: "#374151",
    TEXT_FIELD: "#1F2937",
    MINE_SHAFT: "#2D2D2D",
    BLACK: "#000000", // #000000
    BLACK_SQUEEZE: "#F3F7FB", // #F3F7FB
  
    WHITE: "#FFFFFF",
    BG_LIGHT: "#F9FAFB",
    BG_DOC: "#F5F5F9",
    THUMBNAIL_BG: "#F3F4F6",
  
    BORDER: "#E5E7EB",
    BORDER_DARK: "#D1D5DB",
    /** Matches the footer separator — slightly warmer than BORDER */
    BORDER_FOOTER: "#E5E5E5",

    OVERLAY_BG: "rgba(0,0,0,0.82)",
    OVERLAY_UI: "rgba(255,255,255,0.18)",
    OVERLAY_UI_HOVER: "rgba(255,255,255,0.28)",
    /** Semi-transparent white used for carousel count chip text */
    OVERLAY_COUNT_TEXT: "rgba(255,255,255,0.8)",

    ONBOARDING_PENDING_DRIVER: '#F3BA40', // #F3BA40
    ONBOARDING_PENDING_DISPATCHER: '#F79E1B', // #F79E1B
    ONBOARDING_APPROVED: '#3ABA71', // #3ABA71
    ONBOARDING_REJECTED: '#F34041', // #F34041

    // Hover tint used for the close-panel icon button
    ICON_BTN_HOVER_BG: "#F3F4F6",

    SUCCESS: "#22C55E",
  };
  
  export type UiKitColors = typeof UIKIT_COLORS;